/* eslint-disable class-methods-use-this */
const Cookie = require('js-cookie');
const assign = require('../utils/assign');

/**
 * Creates an instance of CookieStorage.
 * @param {object} [options]
 * @param {number} options.expires Amount of days for cookie expiration. Default: 360
 * @param {string} options.domain Domain for cookies. Default: '' (current domain).
 */
function CookieStorage(options) {
  const defaultOptions = {
    expires: 360,
    domain: '',
  };
  this.baseOptions = assign(defaultOptions, options);
}

CookieStorage.prototype.setItem = function(key, val, options) {
  const params = assign(this.baseOptions, options);
  return Cookie.set(key, val, params);
};

CookieStorage.prototype.getItem = function(key) {
  return Cookie.get(key);
};

CookieStorage.prototype.removeItem = function(key) {
  Cookie.remove(key);
};

module.exports = CookieStorage;
